import type { AxiosInstance } from 'axios'

import { CreateCompanyInputInterface } from '../../interfaces/company'

export const createCompany = (api: AxiosInstance) => (
  companyDetail: CreateCompanyInputInterface
) => api.post('/v1.0/admin/companies', companyDetail)
